import createFetchTypes from '@app/utils/createFetchTypes';

const mainType = 'personalizationSettings';

export const getPersonalizationSettingsTypes = createFetchTypes(
	`${mainType}_GET`,
);
export const upsertPersonalizationSettingsTypes = createFetchTypes(
	`${mainType}_UPSERT`,
);

export type MessageRole = 'welcome' | 'nudge';
export type CampaignPurpose = 'apply' | 'admit' | 'commit' | 'enroll';

export type MessageConfigType = {
	campaignPurpose: CampaignPurpose;
	messageRole: MessageRole;
	enabled: boolean;
};

export type PersonalizationSettingsType = {
	globalConfig: {
		influence: string;
	};
	messageConfig: MessageConfigType[];
};
